import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { IDomainsSlice } from "@/redux/slices/domains/types";

type SearchDomainProps = {
  search: string;
};

export const bulkSearchDomains = createAsyncThunk(
  "domains/bulkSearchNumbers",
  async ({ search }: SearchDomainProps) => {
    const response = await axios({
      method: "POST",
      url: "/api/domain-names/bulk-search",
      data: {
        domains: search.split(/[\s,]+/).filter((query) => query !== ""),
      },
    });

    return response.data;
  }
);

const pending = (state: IDomainsSlice, { meta: { arg } }) => {
  state.bulk = {
    ...state.search,
    category: arg.category,
    value: arg.search,
    loading: true,
    results: {
      available: [],
      unavailable: [],
    },
  };
};

const fulfilled = (state: IDomainsSlice, { payload }) => {
  state.bulk = {
    ...state.search,
    loading: false,
    results: payload,
  };
};

const rejected = (state: IDomainsSlice) => {
  state.bulk = {
    ...state.search,
    loading: false,
    results: {
      available: [],
      unavailable: [],
      errorMessage: "Something went wrong",
    },
  };
};

export default {
  action: bulkSearchDomains,
  pending,
  fulfilled,
  rejected,
};
